/**
 * A consent row: small checkbox beside merchant-authored copy that may contain links.
 *
 * The copy is HTML because the terms row has to link out, which rules out a wrapping <label>:
 * a click on an anchor inside a label toggles the checkbox as well as following the link. The
 * checkbox is named by the copy through aria-labelledby instead, so it still reads correctly.
 *
 * @param {object} props
 * @param {string} props.name
 * @param {boolean} props.value
 * @param {(event: Event) => void} props.onChange
 * @param {string} props.html Merchant copy, already escaped by Liquid on the way in.
 * @param {boolean} [props.required] Blocks submission until ticked, via native validation.
 */
export const FieldConsent = ({ name, value, onChange, html, required = false }) => {
  const textId = `consent-text-${name}`

  return (
    <label
      className={'group-input-label p-4 gap-2 flex flex-row items-start border border-neutrals-medium-grey rounded-default cursor-pointer paragraph-sm focus-within:border-secondary-green focus:outline-secondary-green focus:ring-0 focus:ring-offset-0'}
    >
      <input
        type={'checkbox'}
        className={'mt-0.5 size-4 shrink-0 cursor-pointer focus:ring-0 focus:ring-offset-0 focus:outline-none checked:bg-secondary-green checked:hover:bg-secondary-green'}
        name={name}
        checked={value}
        onChange={onChange}
        required={required}
        aria-labelledby={textId}
      />
      <div
        id={textId}
        className={'richtext richtext-black-url paragraph-sm'}
        dangerouslySetInnerHTML={{ __html: html }}
      ></div>
    </label>
  )
}
